import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { pageSelectors } from 'client/store/page/pageSelectors'
import OrderSummary from 'common/components/entities/OrderSummaryNew'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import EntityInterface from 'common/types/entities/EntityInterface'
import { getCurrencySignByLocale } from 'common/utils/currencyUtils'
import React from 'react'
import i18next from '../../i18n'
import { usePage } from '../../store'

type OfferThankYouOrderSummaryProps = {
  entity: EntityInterface
  isMoveDownAllowed: boolean
  isMoveUpAllowed: boolean
}

function OfferThankYouOrderSummary({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: OfferThankYouOrderSummaryProps) {
  const pageLocale = usePage(pageSelectors.getPageLocale)
  const fixedT = i18next.getFixedT(pageLocale)

  const upsellPricePlansExample = [
    {
      id: 3,
      name: fixedT('entities.offer_upsell_price.stub.name'),
      price: '1400 ' + getCurrencySignByLocale(pageLocale as PageLocaleEnum),
    },
  ]

  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <OrderSummary
        attrId={entity.htmlAttrId}
        pricePlans={upsellPricePlansExample}
      />
    </BaseEntityNew>
  )
}

export default OfferThankYouOrderSummary
